import React from 'react';

const cards = [
  {
    title: 'FlintPay Travel',
    description:
      'Plan and approve business trips seamlessly with built-in policy control and calendar integration.',
    linkLabel: 'Learn about travel',
    image:
      'https://images.unsplash.com/photo-1530521954074-e64f6810b32d?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Airplane wing view from a window'
  },
  {
    title: 'FlintPay Expense',
    description:
      'Automatically capture and validate expenses in real time—no receipts, no delays, no fraud.',
    linkLabel: 'Learn about expense',
    image:
      'https://images.unsplash.com/photo-1543286386-713bdd548da4?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Analytics dashboard on laptop'
  },
  {
    title: 'Payments',
    description:
      'Enable UPI-based payments with pre-approved controls and instant expense reconciliation.',
    linkLabel: 'Learn about payments',
    image:
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Person holding a payment card'
  }
];

const PlatformSection: React.FC = () => {
  return (
    <section className="bg-appbg px-6 py-12 lg:px-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="rounded-[20px] border border-line bg-card px-6 py-10 sm:px-8 lg:px-10">
          <header className="mx-auto max-w-[820px] text-center">
            <h2 className="text-[24px] font-extrabold leading-[1.2] tracking-[-0.02em] text-primary-800">
              The AI-powered business travel and expense platform
            </h2>
            <p className="mx-auto mt-3 max-w-[720px] text-[14px] leading-[1.5] text-muted">
              One integrated solution to manage every aspect of your company spend with precision and ease.
            </p>
          </header>

          <div className="mt-10 grid gap-6 lg:grid-cols-3">
            {cards.map((card) => (
              <article key={card.title} className="group">
                <div className="overflow-hidden rounded-[18px]">
                  <img
                    src={card.image}
                    alt={card.imageAlt}
                    className="h-[230px] w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                    loading="lazy"
                  />
                </div>
                <h3 className="mt-4 text-[24px] font-bold tracking-[-0.01em] text-primary-800 sm:text-[20px]">
                  {card.title}
                </h3>
                <p className="mt-2 text-[14px] leading-[1.5] text-muted">
                  {card.description}
                </p>
                {/* <button
                  type="button"
                  className="mt-4 inline-flex items-center gap-2 text-[14px] font-semibold text-primary-600 transition hover:text-primary-800"
                >
                  <span>{card.linkLabel}</span>
                  <span aria-hidden="true">→</span>
                </button> */}
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformSection;
